import BoxIcon from '@components/Icons/BoxIcon';
import DropboxIcon from '@components/Icons/DropboxIcon';
import FacebookIcon from '@components/Icons/FacebookIcon';
import FrameIoIcon from '@components/Icons/FrameIoIcon';
import GoogleDriveIcon from '@components/Icons/GoogleDriveIcon';
import LinkedInIcon from '@components/Icons/LinkedInIcon';
import ShadeIcon from '@components/Icons/ShadeIcon';
import SoundCloudIcon from '@components/Icons/SoundCloudIcon';
import TikTokIcon from '@components/Icons/TikTokIcon';
import VimeoIcon from '@components/Icons/VimeoIcon';
import YoutubeIcon from '@components/Icons/YoutubeIcon';
import css from './SupportedPlatformsText.module.scss';

export const SupportedPlatformsText = () => {
  return (
    <span className={css.supportText}>
      We support media from {/* prettier-ignore */}
      <span><YoutubeIcon />YouTube,</span> {/* prettier-ignore */}
      <span><VimeoIcon />Vimeo,</span> {/* prettier-ignore */}
      <span><FacebookIcon />Facebook,</span> {/* prettier-ignore */}
      <span><GoogleDriveIcon />Google Drive,</span> {/* prettier-ignore */}
      <span><FrameIoIcon />Frame.io,</span> {/* prettier-ignore */}
      <span><DropboxIcon />Dropbox,</span> {/* prettier-ignore */}
      <span><BoxIcon />Box,</span> {/* prettier-ignore */}
      <span><ShadeIcon />Shade,</span> {/* prettier-ignore */}
      <span><LinkedInIcon />LinkedIn,</span> {/* prettier-ignore */}
      <span><TikTokIcon />TikTok,</span> and {/* prettier-ignore */}
      <span><SoundCloudIcon />SoundCloud.</span>
    </span>
  );
};
